export default "/images/8bb726c740a1dba9e49821f222db44f1.avif";